import React, {useState, useRef, useEffect} from 'react';
import ActionItemColumn from './ActionItemColumn.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = 0;

export default function ActionItem() 
{
    const {action_item, setActionItem, action_item_display_refresh, setActionItemDisplayRefresh, 
           user_changed_action_item, setUserChangedActionItem, setSelectedActionItem, setActionItemListLocalRefresh,
           setActionItemFiles, setActionItemComments, setActionItemCommentFiles,
           setActionItemHistoryEvents, setActionItemTagAssignments, setActionItemReactions, setActionItemCommentReactions} = useCTAL();

    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const fetchRef = useRef("");

    if (DEBUG) console.log(`ActionItem** - ActionItemID from Context: ${action_item.ActionItemID}`);
    
    const populate_all_action_item = (items) => { 
        if (DEBUG) console.log(`ActionItem**** - populate_all_action_item, num action_item (bulk) items: ${items.length}`);

        var action_item_items = items.filter( item => { return (item.Type === "Action-Item"); } );
        if (action_item_items.length != 1) return;
       
        //Making these display changes after the Action-Item has been re-loaded from the DB
        if (user_changed_action_item) {
            setUserChangedActionItem(false);
            setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
            setActionItemListLocalRefresh(true); //This will update the Action-Item entry in the Action Item List (used in ActionItemList.mjs)
        }

        setActionItem(action_item_items[0]); //Refresh this Action Item
        setActionItemFiles( items.filter( item => { return ((item.Type === "File") && (item.TargetType === "Action-Item")); } ) );
        setActionItemComments(items.filter( item => { return (item.Type === "Comment"); } ));
        setActionItemCommentFiles(items.filter( item => { return ((item.Type === "File") && (item.TargetType === "Comment")); } ));
        setActionItemHistoryEvents(items.filter( item => { return (item.Type === "History Event"); } ));
        setActionItemTagAssignments(items.filter( item => { return (item.Type === "Tag Assign"); } ));
        setActionItemReactions(items.filter( item => { return ((item.Type === "Reaction") && (item.TargetType === "Action-Item")); } ));
        setActionItemCommentReactions(items.filter( item => { return ((item.Type === "Reaction") && (item.TargetType === "Comment")); } ));
    }

    useEffect(() =>
    {
        if (!action_item) return;

        var type = "get_action_item_all";
        var action_item_id = action_item.ActionItemID;
        var search_body = JSON.stringify({type, action_item_id});
    
        if ((fetchRef.id == action_item_id) && (!action_item_display_refresh)) return;
        fetchRef.id = action_item_id;

        setActionItemDisplayRefresh(false);

        console.log(`ActionItem - fetching Action-Item (bulk) from ctal-get for: ${action_item_id}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            //.then(setActionItemAll)
            .then(populate_all_action_item)
            .then(() => setLoading(false))
            .catch(setError);
    }, [action_item, action_item_display_refresh]);
    
    if (loading) return <h1>Loading Action...</h1>;
    if (error) return <pre>{JSON.stringify(error, null, 2)}</pre>
    if (!action_item) return null;
      
    if (DEBUG) { console.log(`ActionItem - Name: ${action_item.Name}`); return; }

    return ( <> <ActionItemColumn  /> </> );
}
